import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P20-E1",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page20/Key/E1answerKey.png",
    component: T6v2,
    stylesTextInput: {
      fontSize: "20px",
      background:'none',
      borderBottom:'none'
    },
    hintBox: [
      {
        src: ["<del>desert</del>","dunes","falls","mountain","rocks","sea"],
        borderColor: "rgb(0,103, 178)",
        width: 550,

      },
    ],
    titleQuestion: [
      {
        num: "1",
        title: `
				Label the pictures with the words.
				`,
        color: "rgb(0,103, 178)",
        star:1,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<center><hintBox id='0'></hintBox></center>
          <div style="display:flex; padding-top:20px">
            <img src='img/FriendsPlus/Page20/E1/1.jpg' width='100%' style="padding:20px"/>
            <img src='img/FriendsPlus/Page20/E1/2.jpg' width='100%' style="padding:20px"/>
          </div>
          <div style=" position: absolute; width: 140px; top: 220px; left: 271px;  "><input id='0' value='text' width=''></input></div>
          <div style=" position: absolute; width: 140px; top: 245px; left: 530px; "><input id='1' value='text' width=''></input></div>
          <div style=" position: absolute; width: 140px; top: 215px; left: 810px; "><input id='2' value='text' width=''></input></div>
          <div style=" position: absolute; width: 140px; top: 214px; left: 1070px; "><input id='4' value='text' width=''></input></div>
          <div style=" position: absolute; width: 140px; top: 383px; left: 1055px; "><input id='5' value='text' width=''></input></div>
				`,
        answer: ["dunes", "rocks", "falls","mountain","sea"],
      },
    ],
  },
  2: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P20-E2",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page20/Key/E2answerKey.png",
    component: T6v2,
    inputSize: 70,
    stylesTextInput: {
      fontSize: "17px",
      background:'none',
      borderBottom:'none'
    },
    titleQuestion: [
      {
        num: "2",
        title: `
        Complete the words in the text.
				`,
        color: "rgb(0,103, 178)",
        star:2,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <img src='img/FriendsPlus/Page20/E2/1.jpg' width='100%' style="padding:2px"/>

        <div style=" position: absolute; width: 116px; top: 157px; left: 509px; "><input id='0' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 183px; left: 732px; "><input id='2' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 267px; left: 509px; "><input id='3' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 292px; left: 829px; "><input id='4' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 320px; left: 663px; "><input id='5' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 350px; left: 765px; "><input id='6' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 399px; left: 784px; "><input id='7' value='text' width=''></input></div>
        <div style=" position: absolute; width: 116px; top: 453px; left:688px; "><input id='8' value='text' width=''></input></div>

				`,
        answer: [
          "ceans",
          "eas",
          "unes",
          "eaches",
          "eserts",
          "ivers",
          "alleys",
          "aves",
   
        ],
      },
    ],
  },
  3: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P20-E3",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page20/Key/E3answerKey.png",
    component: Circle_Write,
    inputSize: 180,
    
    titleQuestion: [
      {
        num: "3",
        title: `
        Cross out the incorrect word.
				`,
        color: "rgb(0,103, 178)",
        star:2,
      },
    ],
    isHiddenCheck: false,
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: "-40px",
          fontWeight: 600,
          //fontStyle: "italic",
          color: "",
          fontSize: 21,
          border:'none',
          // borderRadius: "0",
          // marginInline: '-1px',
        },
        selectWordStyle: { borderBottom: "2px solid"  },
        limitSelect: 1,
        listWordsStyle: {},
        listWords: [
          `volcano / valley / rainforest`,
          `cliffs / the_ocean / a_rock`,
          `waves / deserts /<br> dunes`,
          `the_sea / the_ocean / a_mountain`,
          `falls / a_desert /<br> a_lake`,
        ],
        answers: ['0-0', '1-4', '2-0', '3-8', '4-4'],
        initialValue: [],
      },
      Layout: `
      <div style='position:relative'>
          <img src='img/FriendsPlus/Page20/E3/1.jpg' style="padding:2px"/>
				<div style='top:430px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> swim across <b>lakes / <del>beaches</del> / rivers</b> </span>
        </div>

        <div style='top:460px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> cycle through an enormous <br> </span>
            <b><sup>1 </sup></b><input id='0' type='Circle' />
        </div>

        <div style='top:530px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> climb </span>
            <b><sup>2 </sup></b><input id='1' type='Circle' />
        </div>

        <div style='top:570px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> run over sandy </span>
            <b><sup>3 </sup></b><input id='2' type='Circle' />
        </div>

        <div style='top:640px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> swim five kilometres out in<br> </span>
            <b><sup>4 </sup></b><input id='3' type='Circle' />
        </div>

        <div style='top:710px; left:15px ; position:absolute;'>
            <span style="font-size:21px"><b>&#8226;</b> sail around </span>
            <b><sup>5 </sup></b><input id='4' type='Circle' />
        </div>

				</div>
			  `,
    },
  },
  4: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P20-E4",
    audio: "",
    video: "",
    component: T6v2,
    hideBtnFooter: true,
    inputSize: 180,
    textareaStyle: { width: 930 },
    stylesTextInput: {
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "4",
        title: `

        Answer the questions. Give reasons for your answers.
				`,
        color: "rgb(0,103, 178)",
        star:3,
      },
    ],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<div>Which natural features do you think … ?</div>
          
          <div>
            <div><b>1</b> are the most beautiful</div>
            <div><i>I think lakes and rivers are the most beautiful because the calm, blue water is relaxing</i></div>
          </div>

          <div>
            <div><b>2</b> are the most dangerous</div>
            <textarea id="0" rows="2"></textarea>
          </div>

          <div>
            <div><b>3</b> are the best to visit</div>
            <textarea id="0" rows="2"></textarea>
          </div>

          <div>
            <div><b>4</b> have the most interesting wildlife</div>
            <textarea id="0" rows="2"></textarea>
          </div>

				`,
        answer: [],
      },
    ],
  },
  5: {
    unit: "Unit Starter",
    id: "FP8-SB-demo-2023-US-P8-E5",
    audio: "",
    video: "",
    component: T6v2,
    hintBox: [
      {
        src: [
          "I love the smell of banh xeo. It really reminds me of my grandma’s house. It brings back memories of visiting her house when I was little.",
        ],
        borderColor: "rgb(219, 46, 57)",
        arrow: true,
        position: 1,
        width: 600,
      },
    ],
    inputSize: 800,
    stylesTextInput: {
      fontSize: "24px",
    },
    titleQuestion: [
      {
        num: "5",
        title: `
					Talk about which objects and places smell best to you. Which of them bring back memories?
				`,
        color: "rgb(219, 46, 57)",
        prefix: { icons: ["far fa-comment"], text: "USE IT!" },
      },
    ],
    questionImage: [],
    hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<hintbox id='0'></hintbox>
				`,
        answer: [],
      },
    ],
  },
};

export default json;
